import styled from 'styled-components';

export const ObservationContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1rem;
  padding: 0.5rem 1rem 0.5rem 1.5rem;
  color: ${({ theme }) => theme.colors.grayDark4};
  background-color: ${({ theme }) => theme.colors.white};
  & > span.title {
    font-weight: 600;
  }
`;
